import { FC } from 'react'
import { FieldArray, ErrorMessage } from 'formik'
import { useTranslation } from 'react-i18next'
import { ObjectiveInput } from '../../../../types'
import { NoteItem } from './NoteItem'
import { NewNote } from '../formik/NewNote'
import { useAuth } from '../../../../context/auth-context'
import { useDateTime } from '../../../../shared/useDateTime'
import PerText from '../../../../components/custom_components/Text'

interface Props {
  objective: ObjectiveInput
  editable: boolean
}

export const Notes: FC<Props> = ({ objective, editable }) => {
  const [t] = useTranslation()
  const { user } = useAuth()
  const { formatDateToUtcString, utcDateStringToMoment } = useDateTime(user)

  return (
    <div style={{ width: '100%' }}>
      <PerText fontSize="l" mb="s">
        {t('okr.objective.notes.header')}
      </PerText>

      {!editable && (
        <>
          {objective.noteList &&
            [...objective.noteList]
              .slice()
              .sort((a, b) => {
                const date1 = utcDateStringToMoment(a.date)
                const date2 = utcDateStringToMoment(b.date)
                return date1 && date2 && date1.isBefore(date2) ? -1 : date1 && date2 && date1.isAfter(date2) ? 1 : 0
              })
              .map((note, index) => <NoteItem key={index} note={note} editable={editable} />)}
        </>
      )}

      {editable && (
        <>
          <ErrorMessage
            name="notes"
            render={(msg) => (
              <div className={'has-error'}>
                <span className={'ant-form-explain'}>{msg}</span>
              </div>
            )}
          />
          <FieldArray
            name="noteList"
            render={(arrayHelpers) => (
              <>
                {objective.noteList &&
                  [...objective.noteList]
                    .slice()
                    .sort((a, b) => {
                      const date1 = utcDateStringToMoment(a.date)
                      const date2 = utcDateStringToMoment(b.date)
                      return date1 && date2 && date1.isBefore(date2) ? -1 : date1 && date2 && date1.isAfter(date2) ? 1 : 0
                    })
                    .map((note, index) => (
                      <NoteItem key={index} note={note} editable={editable} remove={() => arrayHelpers.remove(index)} />
                    ))}
                <NewNote
                  add={(text: string) => {
                    arrayHelpers.push({
                      author: {
                        id: user.employeeId,
                        lastName: user.lastName,
                        firstName: user.firstName,
                        avatarUrl: user.avatarUrl,
                      },

                      text,
                      date: formatDateToUtcString(new Date()),
                    })
                  }}
                  employeeId={user.employeeId}
                  firstName={user.firstName}
                  lastName={user.lastName}
                  date={t('global.today')}
                />
              </>
            )}
          />
        </>
      )}
    </div>
  )
}
